import { useCallback, useMemo } from "react";
import { useResultadoSorteios } from "../requests";
import produtosSorteioHabitacional from "../../config/produtosSorteioHabitacional.json";

const useResultadoSorteiosHabitacional = () => {
  const {
    error: errorPrincipal,
    loading: loadingPrincipal,
    dataUltimoSorteio,
    resultados: resultadosPrincipal,
    dataSorteios,
    dataBusca: dataBuscaResultado,
    setBusca: setBuscaPrincipal,
  } = useResultadoSorteios();

  const {
    error: errorSecundario,
    loading: loadingSecundario,
    resultados: resultadosSecundario,
    setBusca: setBuscaSecundario,
  } = useResultadoSorteios();

  const resultados = useMemo(() => {
    const todosResultados = [resultadosPrincipal, resultadosSecundario].filter(
      (x) => x
    );
    return todosResultados.length ? todosResultados : null;
  }, [resultadosPrincipal, resultadosSecundario]);

  const getResults = useCallback(
    (params) => {
      const { id, dataBusca } = { ...params };

      const { value } = {
        ...produtosSorteioHabitacional.find(({ id: cId }) => cId === id),
      };
      setBuscaPrincipal({ plano: { value }, dataBusca });

      if (id === "SeguroHabitacionalMaisPremiavel") {
        setBuscaSecundario({ plano: { value: 860.3 }, dataBusca });
      }
    },
    [setBuscaPrincipal, setBuscaSecundario]
  );

  const loading = useMemo(() => loadingPrincipal || loadingSecundario, [
    loadingPrincipal,
    loadingSecundario,
  ]);

  return {
    error: { ...errorPrincipal, ...errorSecundario },
    loading,
    dataSorteios,
    dataUltimoSorteio,
    resultados,
    dataBusca: dataBuscaResultado,
    produtos: produtosSorteioHabitacional,
    getResults,
  };
};

export default useResultadoSorteiosHabitacional;
